<template>
  <div class="information-block">
    <label class="title">{{title}}</label>
    <div class="holder">

      <div class="icon" :class="{noCircle: noCircle}">
        <svgicon :src="icon" width="20" height="20" v-if="icon"/>
        <img :src="img" v-if="img">
      </div>

      <div class="data">

        <div class="information" v-for="(d, dIndex) of nonEmptyData" :key="'data-'+dIndex" :class="{bigger: d.options && d.options.bigger}">
          <span class="label">{{d.label}}</span>
          <span class="value" v-if="d.url">
            <a class="value link" :href="d.value" target="_blank">{{d.value}}</a>
            <svgicon src="icon/link.svg" :height="15" :width="15"></svgicon>
          </span>
          <span class="value" v-if="typeof d.status !== 'undefined'">
            <div class="status" :class="statusToBool(d.status) ? 'valid' : 'invalid'">{{ d.value }}</div>
          </span>
          <span class="value" v-if="typeof d.status === 'undefined' && !d.url" v-html="d.value"/>
        </div>

        <div v-if="actions" class="actions">
          <button class="btn btn-primary" v-if="action.method" v-for="action of actions" @click="action.method">{{action.text}}</button>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
  export default {
    name: "informationBlock",

    props: {
      title: String,
      icon: String,
      img: String,
      actions: Array,
      noCircle: Boolean,
      data: Array /** {{label: string, value: string}}[] **/
    },

    computed: {
      nonEmptyData() {
        return (this.data || []).filter(e => !!e && !!e.value);
      }
    },

    methods: {
      statusToBool(status) {
        if (typeof status === 'boolean') {
          return status;
        }
        status = status.toLowerCase();
        if (status === 'true' || status === 'online' || status === 'active' || status === 'enabled') {
          return true;
        } else if (status === 'false' || status === 'inactive' || status === 'offline' || status === 'disabled') {
          return false;
        } else {
          return status;
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  .information-block {

    margin-bottom: 15px;

    label {
      margin-bottom: 10px;
    }

    .holder {
      box-shadow: 0px 1px 2px #0000001F;
      border-radius: 5px;
      padding: 20px;
      display: flex;
    }

    .icon {
      display: flex;
      width: 40px;
      height: 40px;
      border-radius: 6px;
      background-color: #f5f5f5;
      align-items: center;
      justify-content: center;
      fill: #fc6650;
      margin-right: 20px;
      flex-shrink: 0;

      &.noCircle {
        background-color: transparent;
        border-radius: 0;
      }
    }

    .actions {
      display: flex;
      flex-wrap: wrap;
      margin: 0 -10px;

      .btn {
        margin: 10px;
      }
    }

    .data {
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;

      .information {
        display: flex;
        justify-content: space-between;
        align-items: center;

        &.bigger {
          font-size: 18px;
          font-weight: bold;
        }

        &:not(:last-child) {
          border-bottom: 1px solid #d9d9d9;
          padding-bottom: 10px;
          margin-bottom: 10px;
        }
      }

      .label {
        padding-right: 10px;
        white-space: nowrap;
      }

      .value {
        text-align: right;
        font-weight: bold;
        display: flex;
        flex-wrap: wrap;

        &.link {
          color: #fc6650;
        }

        .status {
          &.invalid {
            color: #BFBFBF;
            &::before {
              background-color: #BFBFBF;
              content: ' ';
              display: inline-block;
              width: 7px;
              height: 7px;
              margin-right: 10px;
              border-radius: 7px;
            }
          }
          &.valid {
            color: #36D53D;
            &::before {
              background-color: #36D53D;
              content: ' ';
              display: inline-block;
              width: 7px;
              height: 7px;
              margin-right: 10px;
              border-radius: 7px;
            }
          }
        }

        .svgicon {
          fill: #fc6650;
          margin-left: 10px;
        }
      }
    }

  }
</style>
